import { View } from "@react-pdf/renderer";
import ContractStyles from "../assets/styles/contractStyles";
import ContractListItem from "../constants/listItem";
import RenderClauses from "../constants/renderClauses";
import { formatSerialNumber, numberClauseTree } from "../constants/serialNumbers";

const obligations = [
  {
    title: "Cessation of the Business",
    content:
      "Following the termination of this Contract the Appointed Representative will:",
    clauses: [
      {
        content: "Immediately stop carrying on the business.",
      },
      {
        content: "Immediately return to the Company all property.",
      },
      {
        content: "Immediately cease to use the Intellectual Property",
      },
      {
        content:
          "To make available to or at the Company’s direction such client files (including files, personal data and other records stored on disc or tape or otherwise) which the Company reasonably requires to meet its compliance obligations or to deal with any complaint.",
      },
    ],
  },
  {
    title: "Financial liability",
    content: "Following the termination of this contract:",
    clauses: [
      {
        content:
          "Any amounts owing by the Appointed Representative to the Company shall immediately become due and payable.",
      },
      {
        content:
          "Any debit balance on the Appointed Representative’s commission account or outstanding liabilities under loan arrangements shall immediately become due and payable.",
      },
      {
        content:
          "The Company reserves the right to suspend payment of any outstanding commission due to the Appointed Representative for a period of up to 12 months or until any debt is cleared.",
      },
      {
        content:
          "The Appointed Representative’s Commission Account will be debited with an amount to cover the costs of providing the Professional Indemnity Arrangement. This amount will be equivalent to one month’s Supervision Fee for each complete year the Appointed Representative has held an Appointed Representative Contract, subject to a minimum of three months and a maximum of twelve months Supervision Fee.",
      },
      {
        content:
          "The Company will withhold all commissions and fees if an Appointed Representative is terminated due to any regulatory breaches.",
      },
    ],
  },
];

const ConsequencesOfTermination = ({ serialNumber = 8 }) => {
  const styles = ContractStyles();

  return (
    <View style={[styles.flexColumn, styles.gap_sm]} break>
      <ContractListItem
        id="consequences-of-termination"
        marker={formatSerialNumber(serialNumber)}
        styles={styles}
        textStyle={[styles.contentSemibold, styles.text_primary]}
      >
        Consequences of Termination
      </ContractListItem>

      <View style={[styles.flexColumn, styles.gap_sm]}>
        {numberClauseTree(obligations, serialNumber).map(({ number, title, content, clauses }) => (
          <View
            key={number}
            style={[
              styles.flexColumn,
              styles.gap_xs,
              // { paddingTop: number === "4.5." ? styles.py_lg : styles.py_md },
            ]}
          >
            <ContractListItem
              marker={number}
              markerWidth={24}
              styles={styles}
              textStyle={styles.buttonTextSmall}
            >
              {title}
            </ContractListItem>
            {content && (
              <ContractListItem
                marker=""
                markerWidth={0}
                styles={styles}
                textStyle={styles.buttonTextSmall}
              >
                {content}
              </ContractListItem>
            )}

            <RenderClauses clauses={clauses} styles={styles} number={number} />
          </View>
        ))}
      </View>
    </View>
  );
};

export default ConsequencesOfTermination;
